"use client";

import React from "react";
import { ArrowRight, TriangleAlert as AlertTriangle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SafetyLabelingCompliance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="safety-labeling-compliance" className="bg-background">
      <div className="bg-[var(--color-logo)] py-16 md:py-24 px-6 md:px-12 lg:px-24">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold mb-6 text-accent">
            How Does Evermark Handle Plant Safety Labeling?
          </h2>
          
          <p className="font-default text-lg md:text-xl text-accent/90 mb-8 leading-relaxed">
            A manufacturing plant carries safety identification governed by recognized standards — ANSI Z535 for safety signs and labels, OSHA 1910.147 for lockout/tagout, and, for electrical rooms and MCCs, NFPA 70E and NEC 110.16 arc flash labeling. Evermark Industrial Solutions produces safety labels and tags designed to align with these standards when properly specified.
          </p>

          <div className="bg-secondary rounded-lg p-6 md:p-8 border-l-4 border-primary mb-10 shadow-lg">
            <div className="flex items-start gap-4">
              <AlertTriangle className="w-6 h-6 text-primary shrink-0 mt-1" aria-hidden="true" />
              <p className="font-default text-base md:text-lg text-accent/90 leading-relaxed">
                Evermark Industrial Solutions produces the physical safety labels, signs, and tags to the content and format specified for the facility. Which standard applies, what a safety label or LOTO tag must say, and whether the identification is adequate are determinations made by the plant, its EHS program, the engineer of record, or a qualified person — not by the label producer. For arc flash labels, Evermark produces the label from the data in the plant's arc flash study and does not perform the study or determine the hazard values. Evermark recommends confirming all safety-identification content with a qualified person.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 sm:gap-10">
            
            
          </div>
        </div>
      </div>
    </section>;
}